import { cva } from "class-variance-authority";

export const inputVariants = cva(
  "flex w-full rounded-md border border-input bg-transparent py-1 text-sm transition-colors placeholder:text-muted-foreground/50 hover:border-accent-10 focus-visible:border-accent-11 focus-visible:outline-hidden focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 error:border-red-11 error:focus-visible:ring-red-4",
  {
    variants: {
      size: {
        xs: "h-full min-h-6 text-xs",
        sm: "h-full min-h-7 px-2",
        md: "h-full min-h-8 px-3",
        lg: "h-full min-h-9 px-4 text-lg",
        xl: "h-12 px-5 text-xl",
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded",
        lg: "rounded-lg",
        full: "rounded-full",
      },
      variant: {
        default: "border-input dark:focus:bg-accent-1A dark:error:focus:bg-accent-1A",
        filled: "border-transparent bg-gray-2",
        ghost: "border-transparent",
        pop: "border-input bg-card shadow-xs hover:shadow-sm",
      },
      prefix: {
        true: "pl-9",
      },
      suffix: {
        true: "pr-9",
      },
    },
    defaultVariants: {
      size: "md",
    },
  }
);
